import { useEffect } from 'react'

const useNotFound = () => {
    useEffect(() => {
        dataLayer.push({
            event: 'error_page_404',
            _clear: true,
        })
    }, [])
}

export default useNotFound
